<template>
  <div class="course-action-page">
    <el-tabs v-model="activeName" class="course-action-tabs" :before-leave="beforeTabLeave">
      <el-tab-pane :label="courseName" name="first">
        <div class="main_r">
          <div class="page-top">
            <div class="title_line">{{ courseName }}</div>
            <div class="toolbar-strip">
              <div class="toolbar-strip__actions">
                <el-button type="primary" size="small" icon="el-icon-back" @click="clickBack">返回</el-button>
                <el-button type="primary" size="small" plain icon="el-icon-refresh" @click="clickQuery">刷新</el-button>
                <el-button type="primary" size="small" icon="el-icon-plus" @click="clickAdd">添加动作到课程</el-button>
              </div>
            </div>
          </div>

          <div class="table-section">
            <div class="table-container" ref="tableContainer">
              <el-table
                ref="courseActionTable"
                row-key="id"
                :data="dataList"
                :height="tableHeight"
                class="course-action-table sortable-table"
                style="width: 100%"
                :header-cell-style="tableHeaderStyle"
                :cell-style="tableCellStyle"
                @expand-change="handleExpandChange"
              >
                <el-table-column label="" width="56" align="center" header-align="center" class-name="col-drag">
                  <template slot="header">
                    <el-tooltip content="拖动排序" placement="top" :enterable="false">
                      <i class="el-icon-rank col-drag-icon"></i>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <i class="el-icon-rank drag-handle" title="拖动排序"></i>
                  </template>
                </el-table-column>
                <el-table-column type="expand" width="48" align="center" header-align="center">
                  <template slot-scope="props">
                    <div class="expand-panel">
                      <el-table
                        :data="props.row.list"
                        height="260"
                        class="inner-table"
                        :header-cell-style="tableHeaderStyle"
                        :cell-style="innerTableCellStyle"
                      >
                        <el-table-column prop="sort" label="动作参数排序" sortable min-width="120" align="center" header-align="center"></el-table-column>
                        <el-table-column prop="parameterType" label="参数类型" sortable min-width="110" align="center" header-align="center">
                          <template slot-scope="props">
                            <span v-if="props.row.parameterType == 1">力量*次数</span>
                            <span v-if="props.row.parameterType == 2">时长</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="power" label="力量" v-if="props.row.calculateType == 1" min-width="90" align="center" header-align="center">
                          <template slot-scope="propsSub">
                            {{ propsSub.row.power }}Kg
                          </template>
                        </el-table-column>
                        <el-table-column prop="trainDate" label="次数" v-if="props.row.calculateType == 1" min-width="90" align="center" header-align="center">
                          <template slot-scope="propsSub">
                            {{ propsSub.row.num }}次
                          </template>
                        </el-table-column>
                        <el-table-column prop="completedPercentage" label="时长" v-if="props.row.calculateType == 2" min-width="90" align="center" header-align="center">
                          <template slot-scope="props">
                            {{ props.row.seconds }}秒
                          </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" sortable min-width="210" align="left" header-align="left" class-name="col-datetime"></el-table-column>
                        <el-table-column label="操作" width="100" align="center" header-align="center" class-name="col-operations">
                          <template slot-scope="scope">
                            <div class="action-group">
                              <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
                                <el-link :underline="false" type="primary" icon="el-icon-edit" @click="ClickEditParameter(scope.row)"></el-link>
                              </el-tooltip>
                              <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                                <el-link :underline="false" type="danger" icon="el-icon-delete" @click="ClickDeleteParameter(scope.row)"></el-link>
                              </el-tooltip>
                            </div>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="sort" label="动作排序" width="88" align="center" header-align="center"></el-table-column>
                <el-table-column prop="actionName" label="动作名称" min-width="160" align="left" header-align="left" show-overflow-tooltip class-name="col-text"></el-table-column>
                <el-table-column label="列表封面" width="96" align="center" header-align="center">
                  <template v-slot="scope">
                    <img :src="scope.row.actionIcon" class="action-cover" alt="" />
                  </template>
                </el-table-column>
                <el-table-column prop="calculateType" label="计算类型" width="96" align="center" header-align="center">
                  <template slot-scope="props">
                    <span v-if="props.row.calculateType == 1" class="calc-badge is-count">计次</span>
                    <span v-if="props.row.calculateType == 2" class="calc-badge is-time">计时</span>
                  </template>
                </el-table-column>
                <el-table-column prop="numGroup" label="组数" width="72" align="center" header-align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="210" align="left" header-align="left" class-name="col-datetime"></el-table-column>
                <el-table-column label="操作" width="168" align="center" header-align="center" class-name="col-operations">
                  <template slot-scope="scope">
                    <div class="action-group">
                      <el-tooltip effect="dark" content="上移" placement="top" :enterable="false">
                        <el-link :underline="false" type="primary" icon="el-icon-top" @click="clickMoveUp(scope.$index, scope.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="下移" placement="top" :enterable="false">
                        <el-link :underline="false" type="primary" icon="el-icon-bottom" @click="clickMoveDown(scope.$index, scope.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="设置动作排序" placement="top" :enterable="false">
                        <el-link :underline="false" type="primary" icon="el-icon-sort" @click="clickdialogEdit(scope.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="删除动作" placement="top" :enterable="false">
                        <el-link :underline="false" type="danger" icon="el-icon-delete" @click="ClickDelete(scope.row)"></el-link>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="添加动作参数" placement="top" :enterable="false">
                        <el-link :underline="false" type="primary" icon="el-icon-plus" @click="ClickAddParameter(scope.row)"></el-link>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="添加动作到课程" name="second">
        <WebTwoCourseActionAdd ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></WebTwoCourseActionAdd>
      </el-tab-pane>

      <!-- 设置动作排序 -->
      <el-dialog title="设置动作排序" :visible.sync="dialogEdit" width="35%" class="newAdd" :close-on-click-modal="false">
        <div class="addUser_body">
          <el-form ref="userMsg" :model="editData" label-width="150px">
            <el-form-item label="动作排序" :required="true">
              <el-input v-model="editData.sort" placeholder="请输入排序"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="CourseActionUpdate()">确定</el-button>
          <el-button @click="dialogEdit = false">取消</el-button>
        </div>
      </el-dialog>

      <!-- 添加动作参数 -->
      <el-dialog title="添加动作参数" :visible.sync="dialogAddParameter" width="35%" class="newAdd" :close-on-click-modal="false">
        <div class="addUser_body">
          <el-form ref="userMsg" :model="addDataParameter" label-width="150px">
            <el-form-item label="力量" :required="true" v-if="addDataParameter.parameterType == 1">
              <el-input v-model="addDataParameter.power" placeholder="请输入力量">
                <template slot="append">
                  <span class="input-unit">KG</span>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="次数" :required="true" v-if="addDataParameter.parameterType == 1">
              <el-input v-model="addDataParameter.num" placeholder="请输入次数">
                <template slot="append">
                  <span class="input-unit">次</span>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="时长" :required="true" v-if="addDataParameter.parameterType == 2">
              <el-input v-model="addDataParameter.seconds" placeholder="请输入时长">
                <template slot="append">
                  <span class="input-unit">秒</span>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="CourseActionParameterInsert()">确定</el-button>
          <el-button @click="dialogAddParameter = false">取消</el-button>
        </div>
      </el-dialog>

      <!-- 编辑动作参数 -->
      <el-dialog title="编辑动作参数" :visible.sync="dialogEditParameter" width="35%" class="newAdd" :close-on-click-modal="false">
        <div class="addUser_body">
          <el-form ref="userMsg" :model="editDataParameter" label-width="150px">
            <el-form-item label="动作参数排序" :required="true">
              <el-input v-model="editDataParameter.sort" placeholder="请输入排序"></el-input>
            </el-form-item>
            <el-form-item label="力量" :required="true" v-if="editDataParameter.parameterType == 1">
              <el-input v-model="editDataParameter.power" placeholder="请输入力量">
                <template slot="append">
                  <span class="input-unit">KG</span>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="次数" :required="true" v-if="editDataParameter.parameterType == 1">
              <el-input v-model="editDataParameter.num" placeholder="请输入次数">
                <template slot="append">
                  <span class="input-unit">次</span>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="时长" :required="true" v-if="editDataParameter.parameterType == 2">
              <el-input v-model="editDataParameter.seconds" placeholder="请输入时长">
                <template slot="append">
                  <span class="input-unit">秒</span>
                </template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="CourseActionParameterUpdate()">确定</el-button>
          <el-button @click="dialogEditParameter = false">取消</el-button>
        </div>
      </el-dialog>
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import Sortable from 'sortablejs'
import WebTwoCourseActionAdd from '@/componentsSubVue/WebTwoCourseActionAdd.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    WebTwoCourseActionAdd
  },
  data () {
    return {
      activeName: 'first',
      courseId: '0',
      courseName: '',
      dataList: [],
      dialogEdit: false,
      editData: {
        id: '',
        sort: ''
      },
      dialogAddParameter: false,
      addDataParameter: {
        sort: '',
        courseActionId: '',
        parameterType: '',
        power: '',
        num: '',
        seconds: ''
      },
      dialogEditParameter: false,
      editDataParameter: {
        sort: '',
        courseActionId: '',
        parameterType: '',
        power: '',
        num: '',
        seconds: '',
        id: ''
      },
      allowChangeTab: false,
      sortableInstance: null,
      tableHasScroll: false,
      tableHeight: 480,
      tableResizeObserver: null
    }
  },
  watch: {
    activeName (val) {
      if (val === 'first') {
        var that = this
        this.$nextTick(function () {
          that.calcTableHeight()
          that.initSortable()
        })
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
    this.destroyTableResizeObserver()
    this.destroySortable()
  },
  mounted () {
    window.addEventListener('resize', this.onWindowResize)
  },
  methods: {
    tableHeaderStyle () {
      return {
        background: '#F5F6F8',
        color: '#5E6670',
        fontWeight: '600'
      }
    },
    tableCellStyle () {
      return {}
    },
    innerTableCellStyle () {
      return { padding: '0' }
    },
    checkTableScroll () {
      var that = this
      this.$nextTick(function () {
        var el = that.$refs.tableContainer
        if (!el) return
        var bodyWrapper = el.querySelector('.el-table__body-wrapper')
        var target = bodyWrapper || el
        that.tableHasScroll = target.scrollWidth > target.clientWidth + 2
      })
    },
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
        that.checkTableScroll()
      })
    },
    initTableResizeObserver () {
      var that = this
      this.calcTableHeight()
      if (typeof ResizeObserver === 'undefined') return
      this.destroyTableResizeObserver()
      this.tableResizeObserver = new ResizeObserver(function () {
        that.calcTableHeight()
      })
      if (this.$refs.tableContainer) {
        this.tableResizeObserver.observe(this.$refs.tableContainer)
      }
    },
    destroyTableResizeObserver () {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
    },
    onWindowResize () {
      this.calcTableHeight()
    },
    handleExpandChange () {
      var that = this
      this.$nextTick(function () {
        if (that.$refs.courseActionTable) {
          that.$refs.courseActionTable.doLayout()
        }
        that.calcTableHeight()
      })
    },
    LoadData (row) {
      this.courseId = row.id
      this.courseName = '【' + row.courseName + '】的动作列表'
      this.activeName = 'first'
      this.CourseActionList()
      this.$nextTick(this.initTableResizeObserver)
    },
    BackToFirst (val) {
      this.activeName = 'first'
      this.CourseActionList()
    },
    clickQuery () {
      this.CourseActionList()
    },
    beforeTabLeave (activeName, oldActiveName) {
      if (!this.allowChangeTab && activeName !== 'first') {
        this.$message.warning('禁止点击')
        return false
      }
      this.allowChangeTab = false
      return true
    },
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    clickAdd () {
      this.allowChangeTab = true
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(this.courseId)
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.sort = row.sort
    },
    ClickDelete (row) {
      var that = this
      this.$deleteConfirm('确定删除？').then(function () {
        that.CourseActionDelete(row.id)
      })
    },
    ClickAddParameter (row) {
      this.dialogAddParameter = true
      this.addDataParameter.sort = '0'
      this.addDataParameter.courseActionId = row.id
      this.addDataParameter.parameterType = row.calculateType
      this.addDataParameter.power = '0'
      this.addDataParameter.num = '0'
      this.addDataParameter.seconds = '0'
    },
    ClickEditParameter (row) {
      this.dialogEditParameter = true
      this.editDataParameter.sort = row.sort
      this.editDataParameter.courseActionId = row.courseActionId
      this.editDataParameter.parameterType = row.parameterType
      this.editDataParameter.power = row.power
      this.editDataParameter.num = row.num
      this.editDataParameter.seconds = row.seconds
      this.editDataParameter.id = row.id
    },
    ClickDeleteParameter (row) {
      var that = this
      this.$deleteConfirm('确定删除该动作参数？').then(function () {
        that.CourseActionParameterDelete(row.id)
      })
    },
    destroySortable () {
      if (this.sortableInstance) {
        this.sortableInstance.destroy()
        this.sortableInstance = null
      }
    },
    initSortable () {
      this.destroySortable()
      var table = this.$refs.courseActionTable
      if (!table) {
        return
      }
      var tbody = table.$el.querySelector('.el-table__body-wrapper tbody')
      if (!tbody) {
        return
      }
      var that = this
      var domIndexToDataIndex = function (domIndex) {
        if (domIndex == null || domIndex < 0) {
          return -1
        }
        var dataIndex = 0
        for (var i = 0; i < domIndex; i++) {
          var row = tbody.children[i]
          if (row.classList.contains('el-table__row') && !row.classList.contains('el-table__expanded-row')) {
            dataIndex++
          }
        }
        return dataIndex
      }
      this.sortableInstance = Sortable.create(tbody, {
        handle: '.drag-handle',
        animation: 150,
        draggable: 'tr.el-table__row',
        filter: '.el-table__expanded-row',
        onEnd: function (evt) {
          if (evt.oldIndex === evt.newIndex) {
            return
          }
          var oldIndex = domIndexToDataIndex(evt.oldIndex)
          var newIndex = domIndexToDataIndex(evt.newIndex)
          if (oldIndex < 0 || newIndex < 0 || oldIndex === newIndex) {
            return
          }
          var moved = that.dataList.splice(oldIndex, 1)[0]
          that.dataList.splice(newIndex, 0, moved)
          that.dataList.forEach(function (row, index) {
            row.sort = index + 1
          })
          that.saveSortOrder()
        }
      })
    },
    saveSortOrder () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.courseId = that.courseId
      that.dataList.forEach(function (row, index) {
        data['sortList[' + index + '].id'] = row.id
        data['sortList[' + index + '].sort'] = index + 1
      })
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionUpdateSort, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            Vue.prototype.$message.success('排序已保存')
            that.CourseActionList()
          } else {
            Vue.prototype.FunRemindAllways(response.data.msg)
            that.CourseActionList()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.CourseActionList()
        })
    },
    clickMoveUp (index, row) {
      if (index === 0) {
        Vue.prototype.FunRemindAllways('已经是第一条了')
        return
      }
      var prevRow = this.dataList[index - 1]
      var newCurrentSort = prevRow.sort
      var newPrevSort = row.sort
      if (newCurrentSort === newPrevSort) {
        newCurrentSort = prevRow.sort - 1
      }
      this.swapSortAndSave([
        { id: row.id, sort: newCurrentSort },
        { id: prevRow.id, sort: newPrevSort }
      ])
    },
    clickMoveDown (index, row) {
      if (index === this.dataList.length - 1) {
        Vue.prototype.FunRemindAllways('已经是最后一条了')
        return
      }
      var nextRow = this.dataList[index + 1]
      var newCurrentSort = nextRow.sort
      var newNextSort = row.sort
      if (newCurrentSort === newNextSort) {
        newCurrentSort = nextRow.sort + 1
      }
      this.swapSortAndSave([
        { id: row.id, sort: newCurrentSort },
        { id: nextRow.id, sort: newNextSort }
      ])
    },
    swapSortAndSave (sortItems) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.courseId = that.courseId
      sortItems.forEach(function (item, index) {
        data['sortList[' + index + '].id'] = item.id
        data['sortList[' + index + '].sort'] = item.sort
      })
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionUpdateSort, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success('操作成功')
            that.CourseActionList()
          } else {
            Vue.prototype.FunRemindAllways(response.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    CourseActionList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.courseId = that.courseId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
            that.$nextTick(function () {
              that.initSortable()
              that.calcTableHeight()
              if (that.$refs.courseActionTable) {
                that.$refs.courseActionTable.doLayout()
              }
            })
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    CourseActionUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.sort = that.editData.sort
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.CourseActionList()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    CourseActionDelete: function (id) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.CourseActionList()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    CourseActionParameterInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sort = that.addDataParameter.sort
      data.courseActionId = that.addDataParameter.courseActionId
      data.parameterType = that.addDataParameter.parameterType
      data.power = that.addDataParameter.power
      data.num = that.addDataParameter.num
      data.seconds = that.addDataParameter.seconds
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionParameterInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.CourseActionList()
            that.dialogAddParameter = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAddParameter = false
        })
    },
    CourseActionParameterUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editDataParameter.id
      data.sort = that.editDataParameter.sort
      data.courseActionId = that.editDataParameter.courseActionId
      data.parameterType = that.editDataParameter.parameterType
      data.power = that.editDataParameter.power
      data.num = that.editDataParameter.num
      data.seconds = that.editDataParameter.seconds
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionParameterUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.CourseActionList()
            that.dialogEditParameter = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    CourseActionParameterDelete: function (id) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionParameterDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.CourseActionList()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.course-action-page {
  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;

  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.course-action-tabs {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/deep/ .course-action-tabs > .el-tabs__header {
  display: none;
}

/deep/ .course-action-tabs.el-tabs--border-card {
  background: transparent;
  border: none;
  box-shadow: none;
}

/deep/ .course-action-tabs > .el-tabs__content {
  flex: 1;
  min-height: 0;
  padding: 0;
  overflow: hidden;
}

/deep/ .course-action-tabs .el-tab-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.main_r {
  height: 100%;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

.toolbar-strip {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 14px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.toolbar-strip__actions {
  display: flex;
  align-items: center;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;
}

.course-action-table {
  width: 100%;

  /deep/ .el-table__body-wrapper,
  /deep/ .el-table__header-wrapper {
    width: 100%;
  }

  /deep/ .el-table__body,
  /deep/ .el-table__header {
    width: 100% !important;
  }

  /deep/ .el-table__body td {
    padding: 10px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
  }

  /deep/ .el-table__header th .cell {
    display: flex;
    align-items: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 12px;
  }

  /deep/ .el-table__body td .cell {
    line-height: 20px;
    padding: 0 12px;
  }

  /deep/ .is-left .cell {
    justify-content: flex-start;
    text-align: left;
  }

  /deep/ .is-center .cell {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/ .col-text .cell {
    display: block;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /deep/ .col-datetime .cell {
    display: block;
    text-align: left;
    white-space: nowrap;
    font-family: 'SF Mono', Monaco, 'Cascadia Code', Consolas, monospace;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.01em;
    color: var(--aptus-text-secondary);
  }

  /deep/ .col-operations .cell {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 8px;
  }

  /deep/ th.col-operations .cell {
    justify-content: center;
  }

  /deep/ .col-drag .cell {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    overflow: visible;
  }

  /deep/ td.col-drag,
  /deep/ th.col-drag {
    overflow: visible;
  }
}

.action-cover {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid var(--aptus-border-light);
}

.calc-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;

  &.is-count {
    background: var(--aptus-primary-bg);
    color: var(--aptus-primary);
  }

  &.is-time {
    background: var(--aptus-accent-bg);
    color: var(--aptus-accent);
  }
}

.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  white-space: nowrap;
  margin: 0 auto;

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--danger:hover {
      background-color: var(--aptus-danger-bg);
    }
  }
}

.expand-panel {
  padding: 8px 12px 12px;
  background: var(--aptus-surface-muted);

  .inner-table {
    width: 100%;
  }
}

.col-drag-icon {
  font-size: 14px;
  color: #9AA3B0;
  cursor: default;
}

.drag-handle {
  cursor: move;
  color: #9AA3B0;
  font-size: 18px;
  transition: color 200ms ease;

  &:hover {
    color: var(--aptus-primary);
  }
}

.input-unit {
  width: 100px;
  display: inline-block;
  text-align: center;
}

.el-form-item {
  margin-bottom: 16px;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.addUser_body {
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
}

/deep/ .el-button--primary.is-plain {
  color: var(--aptus-primary);
  background: var(--aptus-primary-bg);
  border-color: var(--aptus-primary);
}
</style>
